export const GET_NOTIFICATIONS_ASYNC = 'GET_NOTIFICATIONS_ASYNC'
export const GET_NOTIFICATIONS_SUCCESS = 'GET_NOTIFICATIONS_SUCCESS'
export const GET_NOTIFICATIONS_FAIL = 'GET_NOTIFICATIONS_FAIL'

export const UPDATE_NOTIFICATIONS_ASYNC = 'UPDATE_NOTIFICATIONS_ASYNC'
export const UPDATE_NOTIFICATIONS_SUCCESS = 'UPDATE_NOTIFICATIONS_SUCCESS'
export const UPDATE_NOTIFICATIONS_FAIL = 'UPDATE_NOTIFICATIONS_FAIL'

export const APPEND_NOTIFICATIONS_SUCCESS = 'APPEND_NOTIFICATIONS_SUCCESS'
